module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "upgradeAcct",
    staticClass: "upgrade-account-modal",
    class: {
      'has-plan': _vm.user.active_pay,
      'md-theme-show-mode': _vm.showMode,
      'md-theme-default': !_vm.showMode,
      'show-md-dark-mode': _vm.showMode
    },
    attrs: {
      "md-open-from": "#upgradeAcct",
      "md-close-to": "#upgradeAcct"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [_c('md-dialog-content', {
    staticClass: "upgrade-account-modal-content",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "close_modal",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("×")]), _vm._v(" "), (!_vm.user.active_pay) ? _c('div', {
    staticClass: "modal-title"
  }, [(_vm.isIndividual) ? _c('span', [_vm._v("Choose your subscription plan")]) : (_vm.isInstitutional) ? _c('span', [_vm._v("Educational and Institutional Plan")]) : (_vm.isStudentMode) ? _c('span', [_vm._v("Cuelist Student")]) : _c('span', [_vm._v("Cuelist Show Pass")])]) : _c('div', {
    staticClass: "modal-title"
  }, [(_vm.isIndividual || _vm.isStudentMode) ? _c('span', [_vm._v("Switch your subscription plan")]) : _c('span', [_vm._v("Educational and Institutional Plan")])]), _vm._v(" "), (_vm.partnerGrantConflictMessage) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--warning",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.partnerGrantConflictMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.user.active_pay) ? _c('div', [_c('div', {
    staticClass: "plan-type"
  }, [(_vm.isIndividual) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('institutional')
      }
    }
  }, [_vm._v("See our educational and institutional subscription options")]) : _vm._e(), _vm._v(" "), (_vm.isInstitutional) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('individual')
      }
    }
  }, [_vm._v("See our individual user subscription options")]) : _vm._e(), _vm._v(" "), (_vm.isIndividual && _vm.studentPlansConfigured) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('student')
      }
    }
  }, [_vm._v("Are you a student? See Cuelist student pricing")]) : _vm._e(), _vm._v(" "), (_vm.isStudentMode) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('individual')
      }
    }
  }, [_vm._v("See our individual subscription plans")]) : _vm._e(), _vm._v(" "), (!_vm.isShowPass && !_vm.isStudentMode && _vm.showPassPriceId) ? _c('span', {
    staticClass: "plan-type-apart",
    on: {
      "click": function($event) {
        return _vm.setModalMode('showpass')
      }
    }
  }, [_vm._v("Just one production? See the Cuelist Show Pass")]) : _vm._e(), _vm._v(" "), (_vm.isShowPass) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('individual')
      }
    }
  }, [_vm._v("See our subscription plans")]) : _vm._e()]), _vm._v(" "), (_vm.isIndividual) ? _c('div', {
    staticClass: "plan-options-wrapper"
  }, [_c('div', {
    staticClass: "plan-cards plan-cards--individual"
  }, [_c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'monthly',
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist Monthly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$12.99")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/month")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setActivePlan('monthly')
      }
    }
  }, [_vm._v("\n                            Choose plan\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'yearly',
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist Yearly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$129")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setActivePlan('yearly')
      }
    }
  }, [_vm._v("\n                            Choose plan\n                        ")])]), _vm._v(" "), (_vm.dualMonthlyPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'dual_monthly' && !_vm.dualPlansLocked,
      'is-unavailable': _vm.dualPlansLocked,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Monthly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$19.98")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/month")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn",
    class: _vm.dualPlansLocked ? 'plan-card-btn--disabled' : 'plan-card-btn--primary',
    attrs: {
      "type": "button",
      "disabled": _vm.dualPlansLocked
    },
    on: {
      "click": function($event) {
        !_vm.dualPlansLocked && _vm.setActivePlan('dual_monthly')
      }
    }
  }, [(_vm.showDualEligibilityLoader) ? _c('span', [_vm._v("Checking…")]) : (_vm.dualPlansLocked) ? _c('span', [_vm._v("Unavailable")]) : _c('span', [_vm._v("Choose plan")])])]) : _vm._e(), _vm._v(" "), (_vm.dualYearlyPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'dual_yearly' && !_vm.dualPlansLocked,
      'is-unavailable': _vm.dualPlansLocked,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Yearly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$198")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn",
    class: _vm.dualPlansLocked ? 'plan-card-btn--disabled' : 'plan-card-btn--primary',
    attrs: {
      "type": "button",
      "disabled": _vm.dualPlansLocked
    },
    on: {
      "click": function($event) {
        !_vm.dualPlansLocked && _vm.setActivePlan('dual_yearly')
      }
    }
  }, [(_vm.showDualEligibilityLoader) ? _c('span', [_vm._v("Checking…")]) : (_vm.dualPlansLocked) ? _c('span', [_vm._v("Unavailable")]) : _c('span', [_vm._v("Choose plan")])])]) : _vm._e()]), _vm._v(" "), (!_vm.eligibilityLoading && _vm.planModalState === 1) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info"
  }, [_vm._v("\n                    Connect your Notes List account to check eligibility for Cuelist + Notes List plans.\n                    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goConnectNotesList.apply(null, arguments)
      }
    }
  }, [_vm._v("Connect account →")])]) : (!_vm.eligibilityLoading && _vm.planModalState === 2) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--success"
  }, [_vm._v("\n                    Your Notes List account already has an active subscription — you only need Cuelist. Choose Cuelist Monthly or Yearly above.\n                    "), (_vm.dualEligibleAtDate) ? [_vm._v("Dual becomes available once that subscription ends on "), _c('strong', [_vm._v(_vm._s(_vm.dualEligibleAtDate))]), _vm._v(".")] : _vm._e(), _vm._v("\n                    If you are interested in a discounted dual subscription, please complete your purchase at thenoteslist.com\n                ")], 2) : _vm._e()]) : (_vm.isStudentMode) ? _c('div', {
    staticClass: "plan-options-wrapper"
  }, [(_vm.studentState.state === 'ended') ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--warning"
  }, [_vm._v("\n                    " + _vm._s(_vm.studentEndedText) + "\n                ")]) : (_vm.studentState.state === 'returning') ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info"
  }, [_vm._v("\n                    " + _vm._s(_vm.studentReturningText) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-cards plan-cards--student"
  }, _vm._l((_vm.studentCards), function(card) {
    return _c('div', {
      key: card.plan,
      staticClass: "plan-card",
      class: {
        'is-selected': _vm.activePlan === card.plan && !_vm.studentUnavailable,
        'is-unavailable': _vm.studentUnavailable,
        'show-md-dark-mode': _vm.showMode
      }
    }, [_c('div', {
      staticClass: "plan-card-eyebrow"
    }, [_vm._v("Cuelist Student")]), _vm._v(" "), _c('div', {
      staticClass: "plan-card-title"
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('div', {
      staticClass: "plan-card-price"
    }, [_c('span', {
      staticClass: "plan-card-amount"
    }, [_vm._v(_vm._s(card.amount))]), _vm._v(" "), _c('span', {
      staticClass: "plan-card-interval"
    }, [_vm._v(_vm._s(card.per))])]), _vm._v(" "), _c('button', {
      staticClass: "plan-card-btn",
      class: _vm.studentUnavailable ? 'plan-card-btn--disabled' : 'plan-card-btn--primary',
      attrs: {
        "type": "button",
        "disabled": _vm.studentUnavailable
      },
      on: {
        "click": function($event) {
          !_vm.studentUnavailable && _vm.setActivePlan(card.plan)
        }
      }
    }, [(_vm.studentUnavailable) ? _c('span', [_vm._v("Unavailable")]) : _c('span', [_vm._v("Choose plan")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "plan-options-note"
  }, [_c('p', [_vm._v("Student pricing is good for four years from the date you first subscribe. After that, your plan renews at the regular Cuelist price.")]), _vm._v(" "), _c('p', [_vm._v("Promotion codes do not apply.")])])]) : (_vm.isShowPass) ? _c('div', {
    staticClass: "plan-options-wrapper"
  }, [_c('div', {
    staticClass: "plan-cards plan-cards--showpass"
  }, [_c('div', {
    staticClass: "plan-card is-selected",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist Show Pass")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$299")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("one-time, one production")])])])])]) : _c('div', {
    staticClass: "plan-options-wrapper"
  }, [_c('div', {
    staticClass: "plan-cards plan-cards--edu-inst"
  }, [_c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'educational',
      'is-unavailable': !_vm.hasEduEmail,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Educational Plan")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$249")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn",
    class: _vm.hasEduEmail ? 'plan-card-btn--primary' : 'plan-card-btn--disabled',
    attrs: {
      "type": "button",
      "disabled": !_vm.hasEduEmail
    },
    on: {
      "click": function($event) {
        _vm.hasEduEmail && _vm.setActivePlan('educational')
      }
    }
  }, [(!_vm.hasEduEmail) ? _c('span', [_vm._v(".edu required")]) : _c('span', [_vm._v("Choose plan")])])]), _vm._v(" "), _c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'institutional',
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Institutional Plan")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$349")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setActivePlan('institutional')
      }
    }
  }, [_vm._v("\n                            Choose plan\n                        ")])]), _vm._v(" "), (_vm.dualEducationalPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'dual_educational' && !_vm.dualEduUnavailable,
      'is-unavailable': _vm.dualEduUnavailable,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Educational")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$398")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn",
    class: _vm.dualEduUnavailable ? 'plan-card-btn--disabled' : 'plan-card-btn--primary',
    attrs: {
      "type": "button",
      "disabled": _vm.dualEduUnavailable
    },
    on: {
      "click": function($event) {
        !_vm.dualEduUnavailable && _vm.setActivePlan('dual_educational')
      }
    }
  }, [(_vm.showDualEligibilityLoader) ? _c('span', [_vm._v("Checking…")]) : (_vm.bundleDisabled) ? _c('span', [_vm._v("Unavailable")]) : (!_vm.hasEduEmail) ? _c('span', [_vm._v(".edu required")]) : (!_vm.notesListLinked) ? _c('span', [_vm._v("Unavailable")]) : _c('span', [_vm._v("Choose plan")])])]) : _vm._e(), _vm._v(" "), (_vm.resolvedDualInstitutionPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-selected': _vm.activePlan === 'dual_institutional' && !_vm.dualInstUnavailable,
      'is-unavailable': _vm.dualInstUnavailable,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Institutional")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$598")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('button', {
    staticClass: "plan-card-btn",
    class: _vm.dualInstUnavailable ? 'plan-card-btn--disabled' : 'plan-card-btn--primary',
    attrs: {
      "type": "button",
      "disabled": _vm.dualInstUnavailable
    },
    on: {
      "click": function($event) {
        !_vm.dualInstUnavailable && _vm.setActivePlan('dual_institutional')
      }
    }
  }, [(_vm.showDualEligibilityLoader) ? _c('span', [_vm._v("Checking…")]) : (_vm.bundleDisabled) ? _c('span', [_vm._v("Unavailable")]) : (!_vm.notesListLinked) ? _c('span', [_vm._v("Unavailable")]) : _c('span', [_vm._v("Choose plan")])])]) : _vm._e()]), _vm._v(" "), (!_vm.eligibilityLoading && _vm.planModalState === 1) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info"
  }, [_vm._v("\n                    Connect your Notes List account to check eligibility for Cuelist + Notes List Dual plans.\n                    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goConnectNotesList.apply(null, arguments)
      }
    }
  }, [_vm._v("Connect account →")])]) : (!_vm.eligibilityLoading && _vm.planModalState === 2) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--success"
  }, [_vm._v("\n                    Your Notes List account already has an active subscription — Dual Educational / Institutional are unavailable. Choose Cuelist Educational or Institutional above.\n                    "), (_vm.dualEligibleAtDate) ? [_vm._v(" Dual becomes available once that subscription ends on "), _c('strong', [_vm._v(_vm._s(_vm.dualEligibleAtDate))]), _vm._v(".")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-options-note"
  }, [_c('p', [_vm._v("Educational plans require a .edu email address or equivalent.")]), _vm._v(" "), _c('p', [_vm._v("Additional seats can be added from Account Settings after purchase.")]), _vm._v(" "), _c('p', [_vm._v("Dual team seats must also be invited in The Notes List.")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-subscribe-content-wrapper"
  }, [_c('md-layout', {
    staticClass: "plan-subscribe-content-container"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": _vm.user.active_pay ? 100 : 60
    }
  }, [_c('div', {
    staticClass: "plan-subscribe-content"
  }, [(!_vm.user.active_pay) ? _c('div', [(!_vm.isShowPass) ? _c('p', [_vm._v("Free 15 day trial on all first-time subscriptions")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Your payments are SSL encrypted, which means they are 100% safe with us.")]), _vm._v(" "), _c('div', {
    staticClass: "plan-payment-notification",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "notification-title"
  }, [(_vm.isShowPass) ? _c('span', [_vm._v("Cuelist Show Pass")]) : _c('span', [_vm._v("Cuelist " + _vm._s(_vm.strings.plan_label) + " Plan Payment")])]), _vm._v(" "), (_vm.isShowPass) ? _c('div', {
    staticClass: "notification-message"
  }, [_vm._v("\n                                    You will be charged "), _c('span', [_vm._v("$" + _vm._s(_vm.strings.price) + " one time")]), _vm._v(" for a single production."), _c('br'), _vm._v("\n                                    This is a one-time purchase, not a subscription — it permanently unlocks one production for unlimited collaborators."), _c('br'), _vm._v("\n                                    There are no recurring charges.\n                                ")]) : _c('div', {
    staticClass: "notification-message"
  }, [_vm._v("\n                                    You will be charged "), _c('span', [_vm._v("$" + _vm._s((_vm.promoApplied && _vm.promoData && _vm.promoData.valid) ? (_vm.strings.price - (_vm.promoData.amount_off ? (_vm.promoData.amount_off / 100) : (_vm.strings.price * _vm.promoData.percent_off / 100))).toFixed(2) : _vm.strings.price) + " per " + _vm._s(_vm.strings.cycle) + " starting " + _vm._s(_vm.strings.tbd))]), _vm._v("."), _c('br'), _vm._v("\n                                    Your subscription will automatically renew " + _vm._s(_vm.strings.cycle) + "ly on a recurring basis."), _c('br'), _vm._v("\n                                    Cancel your auto renew at any time on your Account Settings page.\n                                ")]), _vm._v(" "), (_vm.isStudentPlanSelected && !_vm.studentUnavailable) ? _c('div', {
    staticClass: "notification-message plan-student-end"
  }, [_vm._v("\n                                    " + _vm._s(_vm.studentEndLineForSelected) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.isInstitutional) ? _c('div', {
    staticClass: "notification-message"
  }, [_vm._v("\n                                    " + _vm._s(_vm.strings.plan_label) + " plan includes "), _c('span', [_vm._v("five active individual accounts")]), _vm._v(" at any one time."), _c('br'), _vm._v("\n                                    Plan administrator can change active users at any point during the subscription period."), _c('br'), _vm._v("\n                                    Additional user licenses can be purchased at a discounted rate after checkout at the MANAGE ACTIVE USERS portal.\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.activePlan == 'educational') ? _c('div', {
    staticClass: "notification-message"
  }, [_vm._v("\n                                    Educational pricing requires a .edu email address or equivalent on your account.\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.activePlan == 'educational' && !_vm.hasEduEmail) ? _c('div', {
    staticClass: "notification-message",
    staticStyle: {
      "color": "#c62828"
    }
  }, [_vm._v("\n                                    Your account email is not a .edu address. Update your email or choose Institutional / Individual.\n                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subscription-terms-privacy"
  }, [(_vm.isDualPlanSelected) ? _c('md-checkbox', {
    model: {
      value: (_vm.termsandpolicy),
      callback: function($$v) {
        _vm.termsandpolicy = $$v
      },
      expression: "termsandpolicy"
    }
  }, [_vm._v("\n                                    By proceeding you agree to the Cuelist "), _c('a', {
    attrs: {
      "href": "https://thecuelist.com/terms-of-use",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://thecuelist.com/privacy",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(", and The Notes List "), _c('a', {
    attrs: {
      "href": "https://thenoteslist.com/policies/terms",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://thenoteslist.com/policies/privacy",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n                                ")]) : _c('md-checkbox', {
    model: {
      value: (_vm.termsandpolicy),
      callback: function($$v) {
        _vm.termsandpolicy = $$v
      },
      expression: "termsandpolicy"
    }
  }, [_vm._v("\n                                    By proceeding you agree to the "), _c('a', {
    attrs: {
      "href": "https://thecuelist.com/terms-of-use",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://thecuelist.com/privacy",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n                                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "plan-subscribe-button-wrapper"
  }, [_c('form', {
    ref: "checkoutForm",
    attrs: {
      "method": "POST",
      "action": _vm.actionUrl
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitCheckout.apply(null, arguments)
      }
    }
  }, [_c('md-button', {
    staticClass: "md-raised btn-subscribe-plan",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmitCheckout
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.isShowPass) ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "mode",
      "value": "payment"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isStudentPlanSelected) ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "on_error",
      "value": "redirect"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "customer_id"
    },
    domProps: {
      "value": _vm.user.stripe_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "product"
    },
    domProps: {
      "value": _vm.activePlanId
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "email_id"
    },
    domProps: {
      "value": _vm.user.email
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "user_id"
    },
    domProps: {
      "value": _vm.user.uid
    }
  })], 1)])]) : _c('div', {
    staticClass: "plan-switch-panel"
  }, [_c('p', {
    staticClass: "plan-current-line"
  }, [_vm._v("\n                                Current plan:\n                                "), _c('span', {
    staticClass: "plan-current-name"
  }, [_vm._v(_vm._s(_vm.isOnDual ? _vm.currentDualLabel : _vm.currentPlanLabel))]), _vm._v(" "), (_vm.isOnStudentPrice) ? _c('span', {
    staticClass: "plan-current-student-end"
  }, [_vm._v(_vm._s(_vm.studentEndLineForCurrent))]) : _vm._e()]), _vm._v(" "), (!_vm.showCancelConfirm) ? _c('div', {
    staticClass: "plan-type"
  }, [(_vm.isIndividual) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('institutional')
      }
    }
  }, [_vm._v("See our educational and institutional subscription options")]) : _vm._e(), _vm._v(" "), (_vm.isIndividual && _vm.canSeeStudentFromSwitch) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('student')
      }
    }
  }, [_vm._v("Are you a student? See Cuelist student pricing")]) : _vm._e(), _vm._v(" "), (_vm.isStudentMode && _vm.isOnStudentPrice) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('individual')
      }
    }
  }, [_vm._v("See regular Cuelist pricing")]) : _vm._e(), _vm._v(" "), (_vm.isStudentMode && _vm.isOnStudentPrice) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('institutional')
      }
    }
  }, [_vm._v("See our educational and institutional subscription options")]) : _vm._e(), _vm._v(" "), (_vm.isStudentMode && !_vm.isOnStudentPrice) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('individual')
      }
    }
  }, [_vm._v("See our individual subscription plans")]) : _vm._e(), _vm._v(" "), (_vm.isInstitutional) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.setModalMode('individual')
      }
    }
  }, [_vm._v("See our individual user subscription options")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.showCancelConfirm) ? [(_vm.isIndividual) ? _c('div', {
    staticClass: "plan-cards plan-cards--individual"
  }, [_c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isCurrentMonthly && !_vm.isOnDual && !_vm.isOnStudentPrice,
      'is-unavailable': _vm.isOnEduInstFamily || _vm.isOnStudentPrice || (_vm.user.pending_cancel && !(_vm.isCurrentMonthly && !_vm.isOnDual)),
      'is-pending-confirm': _vm.isPendingCuelistMonthly,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), (_vm.isCurrentMonthly && !_vm.isOnDual && !_vm.isOnStudentPrice) ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist Monthly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$12.99")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/month")])]), _vm._v(" "), (_vm.isCurrentMonthly && !_vm.isOnDual && !_vm.isOnStudentPrice) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.isOnDualIndividual && !_vm.user.pending_cancel) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectDowngradeTarget('month')
      }
    }
  }, [(_vm.isPlanActionBusy('downgrade', 'month')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('downgrade', 'month') ? 'Switching…' : 'Switch plan') + "\n                                    ")]) : (_vm.isCurrentYearly && !_vm.isOnDual && !_vm.isOnStudentPrice && !_vm.user.pending_cancel) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectCuelistIntervalSwitch('month')
      }
    }
  }, [(_vm.isPlanActionBusy('cuelist_interval', 'month')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('cuelist_interval', 'month') ? 'Switching…' : 'Switch plan') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isCurrentYearly && !_vm.isOnDual && !_vm.isOnStudentPrice,
      'is-unavailable': _vm.isOnEduInstFamily || _vm.isOnStudentPrice || (_vm.user.pending_cancel && !(_vm.isCurrentYearly && !_vm.isOnDual)),
      'is-pending-confirm': _vm.isPendingCuelistYearly,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), (_vm.isCurrentYearly && !_vm.isOnDual && !_vm.isOnStudentPrice) ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist Yearly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$129")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), (_vm.isCurrentYearly && !_vm.isOnDual && !_vm.isOnStudentPrice) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.isOnDualIndividual && !_vm.user.pending_cancel) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectDowngradeTarget('year')
      }
    }
  }, [(_vm.isPlanActionBusy('downgrade', 'year')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('downgrade', 'year') ? 'Switching…' : 'Switch plan') + "\n                                    ")]) : (_vm.isIndividualActivePlan && !_vm.isOnDual && !_vm.isOnStudentPrice && !_vm.isCurrentYearly && !_vm.user.pending_cancel) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectCuelistIntervalSwitch('year')
      }
    }
  }, [(_vm.isPlanActionBusy('cuelist_interval', 'year')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('cuelist_interval', 'year') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]), _vm._v(" "), (_vm.dualMonthlyPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isOnDualIndividual && _vm.currentDualInterval === 'month',
      'is-unavailable': (!_vm.isOnDualIndividual && !_vm.canUpgradeToDualMonthly) || _vm.isOnEduInstFamily,
      'is-pending-confirm': _vm.isPendingDualMonthly,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), (_vm.isOnDualIndividual && _vm.currentDualInterval === 'month') ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Monthly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$19.98")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/month")])]), _vm._v(" "), (_vm.isOnDualIndividual && _vm.currentDualInterval === 'month') ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.isOnDualIndividual && _vm.currentDualInterval === 'year' && _vm.notesListLinked && !_vm.user.pending_cancel) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.dualUpgradeWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectDualUpgrade('month')
      }
    }
  }, [(_vm.isPlanActionBusy('upgrade_dual', 'month')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('upgrade_dual', 'month') ? 'Switching…' : 'Switch plan') + "\n                                    ")]) : (_vm.canUpgradeToDualMonthly) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.dualUpgradeWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectDualUpgrade('month')
      }
    }
  }, [(_vm.isPlanActionBusy('upgrade_dual', 'month')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('upgrade_dual', 'month') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.dualYearlyPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isOnDualIndividual && _vm.currentDualInterval === 'year',
      'is-unavailable': (!_vm.isOnDualIndividual && !_vm.canUpgradeToDualYearly) || _vm.isOnEduInstFamily,
      'is-pending-confirm': _vm.isPendingDualYearly,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), (_vm.isOnDualIndividual && _vm.currentDualInterval === 'year') ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Yearly")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$198")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), (_vm.isOnDualIndividual && _vm.currentDualInterval === 'year') ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.isOnDualIndividual && _vm.currentDualInterval === 'month' && _vm.notesListLinked && !_vm.user.pending_cancel) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.dualUpgradeWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectDualUpgrade('year')
      }
    }
  }, [(_vm.isPlanActionBusy('upgrade_dual', 'year')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('upgrade_dual', 'year') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : (_vm.canUpgradeToDualYearly) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.dualUpgradeWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectDualUpgrade('year')
      }
    }
  }, [(_vm.isPlanActionBusy('upgrade_dual', 'year')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('upgrade_dual', 'year') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isStudentMode) ? [(_vm.studentState.state === 'ended') ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--warning"
  }, [_vm._v("\n                                " + _vm._s(_vm.studentEndedText) + "\n                            ")]) : (_vm.studentState.state === 'returning') ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info"
  }, [_vm._v("\n                                " + _vm._s(_vm.studentReturningText) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-cards plan-cards--student"
  }, _vm._l((_vm.studentCards), function(card) {
    return _c('div', {
      key: card.plan,
      staticClass: "plan-card",
      class: {
        'is-current': _vm.studentCurrentInterval === card.interval,
        'is-unavailable': _vm.studentCurrentInterval !== card.interval && !_vm.studentCardAction(card),
        'is-pending-confirm': _vm.isPendingStudent(card.interval),
        'show-md-dark-mode': _vm.showMode
      }
    }, [_c('div', {
      staticClass: "plan-card-top"
    }, [_c('div', {
      staticClass: "plan-card-eyebrow"
    }, [_vm._v("Cuelist Student")]), _vm._v(" "), (_vm.studentCurrentInterval === card.interval) ? _c('span', {
      staticClass: "plan-card-badge"
    }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "plan-card-title"
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('div', {
      staticClass: "plan-card-price"
    }, [_c('span', {
      staticClass: "plan-card-amount"
    }, [_vm._v(_vm._s(card.amount))]), _vm._v(" "), _c('span', {
      staticClass: "plan-card-interval"
    }, [_vm._v(_vm._s(card.per))])]), _vm._v(" "), (_vm.studentCurrentInterval === card.interval) ? _c('button', {
      staticClass: "plan-card-btn plan-card-btn--outline",
      attrs: {
        "type": "button",
        "disabled": !_vm.user.stripe_id
      },
      on: {
        "click": _vm.openManageBilling
      }
    }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.studentCardAction(card) === 'upgrade') ? _c('button', {
      staticClass: "plan-card-btn plan-card-btn--primary",
      attrs: {
        "type": "button",
        "disabled": _vm.switchWorking || _vm.user.pending_cancel
      },
      on: {
        "click": function($event) {
          return _vm.selectCuelistIntervalSwitch(card.interval)
        }
      }
    }, [(_vm.isPlanActionBusy('cuelist_interval', card.interval)) ? _c('span', {
      staticClass: "plan-card-btn-spinner",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('cuelist_interval', card.interval) ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : (_vm.studentCardAction(card) === 'interval') ? _c('button', {
      staticClass: "plan-card-btn plan-card-btn--outline",
      attrs: {
        "type": "button",
        "disabled": _vm.switchWorking || _vm.user.pending_cancel
      },
      on: {
        "click": function($event) {
          return _vm.selectCuelistIntervalSwitch(card.interval)
        }
      }
    }, [(_vm.isPlanActionBusy('cuelist_interval', card.interval)) ? _c('span', {
      staticClass: "plan-card-btn-spinner",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('cuelist_interval', card.interval) ? 'Switching…' : 'Switch plan') + "\n                                    ")]) : (_vm.studentCardAction(card) === 'switch') ? _c('button', {
      staticClass: "plan-card-btn plan-card-btn--outline",
      attrs: {
        "type": "button",
        "disabled": _vm.switchWorking || _vm.user.pending_cancel
      },
      on: {
        "click": function($event) {
          return _vm.selectStudentSwitch(card.interval)
        }
      }
    }, [(_vm.isPlanActionBusy('student', card.interval)) ? _c('span', {
      staticClass: "plan-card-btn-spinner",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('student', card.interval) ? 'Switching…' : 'Switch plan') + "\n                                    ")]) : _c('button', {
      staticClass: "plan-card-btn plan-card-btn--disabled",
      attrs: {
        "type": "button",
        "disabled": ""
      }
    }, [_vm._v("\n                                        Unavailable\n                                    ")])])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.isInstitutional) ? _c('div', {
    staticClass: "plan-cards plan-cards--edu-inst"
  }, [_c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isCurrentEducational,
      'is-unavailable': !_vm.isCurrentEducational && !_vm.canUpgradeToEducational,
      'is-pending-confirm': _vm.isPendingEducational,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), (_vm.isCurrentEducational) ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Educational Plan")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$249")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), (_vm.isCurrentEducational) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.canUpgradeToEducational) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectTeamUpgrade('educational')
      }
    }
  }, [(_vm.isPlanActionBusy('team_upgrade', 'educational')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('team_upgrade', 'educational') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : (!_vm.hasEduEmail && _vm.canUpgradeToCuelistTeamBase) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        .edu required\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isCurrentInstitutional,
      'is-unavailable': !_vm.isCurrentInstitutional && !_vm.canUpgradeToInstitutional,
      'is-pending-confirm': _vm.isPendingInstitutional,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow"
  }, [_vm._v("Cuelist")]), _vm._v(" "), (_vm.isCurrentInstitutional) ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Institutional Plan")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$349")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), (_vm.isCurrentInstitutional) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.canUpgradeToInstitutional) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectTeamUpgrade('institutional')
      }
    }
  }, [(_vm.isPlanActionBusy('team_upgrade', 'institutional')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('team_upgrade', 'institutional') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]), _vm._v(" "), (_vm.dualEducationalPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isCurrentDualEducational,
      'is-unavailable': !_vm.isCurrentDualEducational && !_vm.canUpgradeToDualEducational,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), (_vm.isCurrentDualEducational) ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Educational")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$398")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), (_vm.isCurrentDualEducational) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.canUpgradeToDualEducational) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectTeamUpgrade('dual_educational')
      }
    }
  }, [(_vm.isPlanActionBusy('team_upgrade', 'dual_educational')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('team_upgrade', 'dual_educational') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]) : _vm._e(), _vm._v(" "), (_vm.resolvedDualInstitutionPlanId) ? _c('div', {
    staticClass: "plan-card",
    class: {
      'is-current': _vm.isCurrentDualInstitutional,
      'is-unavailable': !_vm.isCurrentDualInstitutional && !_vm.canUpgradeToDualInstitutional,
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "plan-card-top"
  }, [_c('div', {
    staticClass: "plan-card-eyebrow plan-card-eyebrow--dual"
  }, [_vm._v("Cuelist + Notes List")]), _vm._v(" "), (_vm.isCurrentDualInstitutional) ? _c('span', {
    staticClass: "plan-card-badge"
  }, [_vm._v("Current")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-title"
  }, [_vm._v("Cuelist + Notes List Institutional")]), _vm._v(" "), _c('div', {
    staticClass: "plan-card-price"
  }, [_c('span', {
    staticClass: "plan-card-amount"
  }, [_vm._v("$598")]), _vm._v(" "), _c('span', {
    staticClass: "plan-card-interval"
  }, [_vm._v("/year")])]), _vm._v(" "), (_vm.isCurrentDualInstitutional) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--outline",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.stripe_id
    },
    on: {
      "click": _vm.openManageBilling
    }
  }, [_vm._v("\n                                        Manage Billing\n                                    ")]) : (_vm.canUpgradeToDualInstitutional) ? _c('button', {
    staticClass: "plan-card-btn plan-card-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking || _vm.user.pending_cancel
    },
    on: {
      "click": function($event) {
        return _vm.selectTeamUpgrade('dual_institution')
      }
    }
  }, [(_vm.isPlanActionBusy('team_upgrade', 'dual_institution')) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.isPlanActionBusy('team_upgrade', 'dual_institution') ? 'Upgrading…' : 'Upgrade') + "\n                                    ")]) : _c('button', {
    staticClass: "plan-card-btn plan-card-btn--disabled",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n                                        Unavailable\n                                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isInstitutional && !_vm.eligibilityLoading && !_vm.notesListLinked) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v("\n                                Connect your Notes List account to check eligibility for Cuelist + Notes List Dual plans.\n                                "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goConnectNotesList.apply(null, arguments)
      }
    }
  }, [_vm._v("Connect account →")])]) : (_vm.isInstitutional && !_vm.eligibilityLoading && _vm.showDualAlreadyLicensedBanner) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--success",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v("\n                                Your Notes List account already has an active subscription — Dual Educational / Institutional are unavailable. Choose Cuelist Educational or Institutional above.\n                                "), (_vm.dualEligibleAtDate) ? [_vm._v(" Dual becomes available once that subscription ends on "), _c('strong', [_vm._v(_vm._s(_vm.dualEligibleAtDate))]), _vm._v(".")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.user.pending_downgrade) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info plan-state-banner--with-action",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('span', [_vm._v("\n                                    A switch to Cuelist Individual is scheduled for " + _vm._s(_vm.formatDowngradeAt(_vm.user.downgrade_at)) + ".\n                                    You keep Dual access until then.\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "plan-banner-action-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.switchWorking
    },
    on: {
      "click": _vm.cancelScheduledDowngrade
    }
  }, [(_vm.switchWorking && !_vm.pendingConfirmAction) ? _c('span', {
    staticClass: "plan-banner-action-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                    " + _vm._s(_vm.switchWorking && !_vm.pendingConfirmAction ? 'Keeping…' : 'Keep Dual') + "\n                                ")])]) : _vm._e(), _vm._v(" "), (_vm.user.pending_cancel) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--warning plan-state-banner--with-action",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('span', [_vm._v("\n                                    Your subscription is scheduled to cancel" + _vm._s(_vm.cancelPeriodEndDate ? ' on ' + _vm.cancelPeriodEndDate : ' at the end of the billing period') + ".\n                                    You keep access until then.\n                                    "), _c('br'), _vm._v("\n                                    Plan switching is disabled while a cancellation is scheduled — keep your plan first if you want to switch.\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "plan-banner-action-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.doing
    },
    on: {
      "click": _vm.keepScheduledCuelistCancellation
    }
  }, [(_vm.doing) ? _c('span', {
    staticClass: "plan-banner-action-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                    " + _vm._s(_vm.doing ? 'Keeping…' : 'Keep my plan') + "\n                                ")])]) : _vm._e(), _vm._v(" "), (_vm.pendingConfirmAction) ? _c('div', {
    staticClass: "plan-confirm-panel"
  }, [_c('div', {
    staticClass: "plan-confirm-panel-header"
  }, [_c('svg', {
    staticClass: "plan-confirm-panel-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "18",
      "height": "18",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4.5",
      "y": "10.5",
      "width": "15",
      "height": "9",
      "rx": "2",
      "stroke": "currentColor",
      "stroke-width": "1.8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 10.5V7.5a4 4 0 0 1 8 0v3",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "plan-confirm-panel-title"
  }, [_vm._v("\n                                        " + _vm._s(_vm.pendingConfirmAction.type === 'downgrade' || _vm.pendingConfirmAction.type === 'student' ? 'Confirm switch' : 'Confirm payment') + "\n                                    ")])]), _vm._v(" "), (_vm.pendingConfirmSummary) ? _c('p', {
    staticClass: "plan-confirm-panel-plan"
  }, [_vm._v(_vm._s(_vm.pendingConfirmSummary))]) : _vm._e(), _vm._v(" "), (_vm.switchWorking && !_vm.switchPreview && !_vm.switchError) ? _c('p', {
    staticClass: "plan-confirm-panel-amount"
  }, [_vm._v("\n                                    Checking amount…\n                                ")]) : (_vm.switchPreview) ? _c('p', {
    staticClass: "plan-confirm-panel-amount"
  }, [(_vm.switchPreview.deferred) ? _c('span', [_vm._v(_vm._s(_vm.switchPreview.message))]) : (_vm.switchPreview.same_price) ? _c('span', [_vm._v("You're already on this plan.")]) : (_vm.isTrialing && _vm.trialEndDate) ? _c('span', [_vm._v("\n                                        You're still in your free trial — switching now keeps your remaining trial days at no charge. Your new plan's pricing starts on "), _c('strong', [_vm._v(_vm._s(_vm.trialEndDate))]), _vm._v(", when your trial ends.\n                                    ")]) : _c('span', [_vm._v("Estimated charge today: "), _c('strong', [_vm._v("$" + _vm._s(_vm.switchPreview.amount_due_display || '0.00'))])])]) : _vm._e(), _vm._v(" "), (_vm.switchPreview && _vm.confirmExtraLines.length) ? _c('p', {
    staticClass: "plan-confirm-panel-amount"
  }, [_vm._l((_vm.confirmExtraLines), function(line, i) {
    return [(i) ? _c('br', {
      key: 'br' + i
    }) : _vm._e(), _c('span', {
      key: 'l' + i
    }, [_vm._v(_vm._s(line))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.switchError) ? _c('p', {
    staticClass: "plan-confirm-panel-error"
  }, [_vm._v(_vm._s(_vm.switchError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-confirm-panel-actions"
  }, [_c('md-button', {
    staticClass: "md-raised btn-subscribe-plan",
    attrs: {
      "disabled": _vm.switchWorking || _vm.dualUpgradeWorking || _vm.doing || _vm.user.pending_cancel || !(_vm.switchPreview || _vm.pendingConfirmAction.type === 'downgrade')
    },
    on: {
      "click": _vm.runPendingConfirmAction
    }
  }, [(_vm.switchWorking || _vm.dualUpgradeWorking || _vm.doing) ? _c('span', {
    staticClass: "plan-card-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.pendingConfirmLabel) + "\n                                    ")]), _vm._v(" "), _c('a', {
    staticClass: "plan-confirm-panel-cancel",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearPendingSwitch.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                                        Cancel\n                                    ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isIndividual && !_vm.eligibilityLoading && !_vm.notesListLinked) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--info",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v("\n                                Connect your Notes List account to check eligibility for Cuelist + Notes List plans.\n                                "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goConnectNotesList.apply(null, arguments)
      }
    }
  }, [_vm._v("Connect account →")])]) : (_vm.isIndividual && !_vm.eligibilityLoading && _vm.showDualAlreadyLicensedBanner) ? _c('div', {
    staticClass: "plan-state-banner plan-state-banner--success",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v("\n                                Your Notes List account has its own active subscription, so Cuelist + Notes List plans aren't available.\n                                Your current Cuelist plan already works alongside Notes List - there's nothing more to buy.\n                                "), (_vm.dualEligibleAtDate) ? [_vm._v("Dual becomes available once that subscription ends on "), _c('strong', [_vm._v(_vm._s(_vm.dualEligibleAtDate))]), _vm._v(".")] : _vm._e(), _vm._v("\n                                If you’d prefer a discounted dual subscription, you can purchase it at thenoteslist.com\n                            ")], 2) : _vm._e(), _vm._v(" "), (!_vm.user.pending_cancel) ? _c('div', {
    staticClass: "plan-cancel-footer"
  }, [_c('button', {
    staticClass: "plan-cancel-link",
    attrs: {
      "type": "button",
      "disabled": !_vm.user.subscription_id
    },
    on: {
      "click": _vm.openCancelConfirm
    }
  }, [_vm._v("\n                                    Cancel subscription\n                                ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showCancelConfirm) ? _c('div', {
    staticClass: "plan-cancel-box"
  }, [_c('div', {
    staticClass: "plan-cancel-box-title"
  }, [_vm._v("Cancel your subscription?")]), _vm._v(" "), (_vm.isOnDual) ? _c('p', {
    staticClass: "plan-cancel-box-body"
  }, [(_vm.cancelPeriodEndDate) ? [_vm._v("\n                                        This ends "), _c('strong', [_vm._v("both your Cuelist and Notes List")]), _vm._v(" access on\n                                        "), _c('strong', [_vm._v(_vm._s(_vm.cancelPeriodEndDate))]), _vm._v(" — the end of your current billing period, including structure sync.\n                                    ")] : [_vm._v("\n                                        This ends "), _c('strong', [_vm._v("both your Cuelist and Notes List")]), _vm._v(" access at\n                                        "), _c('strong', [_vm._v("the end of your current billing period")]), _vm._v(", including structure sync.\n                                    ")]], 2) : _c('p', {
    staticClass: "plan-cancel-box-body"
  }, [(_vm.cancelPeriodEndDate) ? [_vm._v("\n                                        This ends your Cuelist access on\n                                        "), _c('strong', [_vm._v(_vm._s(_vm.cancelPeriodEndDate))]), _vm._v(" — the end of your current billing period. You’ll keep full access until then.\n                                    ")] : [_vm._v("\n                                        This ends your Cuelist access at\n                                        "), _c('strong', [_vm._v("the end of your current billing period")]), _vm._v(". You’ll keep full access until then.\n                                    ")]], 2), _vm._v(" "), (!_vm.isOnDual) ? _c('div', {
    staticClass: "plan-cancel-note"
  }, [_vm._v("\n                                    If you separately subscribe to Notes List, that subscription is unaffected — manage it from your Notes List account settings. Structure sync between the apps will stop once your Cuelist plan ends.\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.switchError) ? _c('div', {
    staticClass: "notification-message",
    staticStyle: {
      "color": "#c62828",
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.switchError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-cancel-actions"
  }, [_c('button', {
    staticClass: "plan-cancel-btn plan-cancel-btn--keep",
    attrs: {
      "type": "button",
      "disabled": _vm.doing
    },
    on: {
      "click": function($event) {
        _vm.showCancelConfirm = false;
        _vm.switchError = ''
      }
    }
  }, [_vm._v("\n                                        Keep my plan\n                                    ")]), _vm._v(" "), _c('button', {
    staticClass: "plan-cancel-btn plan-cancel-btn--confirm",
    attrs: {
      "type": "button",
      "disabled": _vm.doing
    },
    on: {
      "click": _vm.confirmCancelSubscription
    }
  }, [(_vm.doing) ? _c('span', {
    staticClass: "plan-cancel-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm.doing ? 'Canceling…' : 'Cancel subscription') + "\n                                    ")])])]) : _vm._e()], 2)])]), _vm._v(" "), (!_vm.user.active_pay) ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('div', {
    staticClass: "billing-details",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('div', {
    staticClass: "billing-details-title"
  }, [(_vm.isShowPass) ? _c('span', [_vm._v("Cuelist Show Pass")]) : (_vm.isStudentPlanSelected) ? _c('span', [_vm._v("Cuelist " + _vm._s(_vm.strings.plan_label) + " Account")]) : _c('span', [_vm._v("Cuelist " + _vm._s(_vm.strings.plan_label) + " Collaborator Account")])]), _vm._v(" "), _c('ul', {
    staticClass: "billing-details-checklist"
  }, _vm._l((_vm.strings.checklist), function(text) {
    return _c('li', [_vm._v(_vm._s(text))])
  }), 0), _vm._v(" "), (_vm.isShowPass) ? _c('div', {
    staticClass: "billing-details-list billing-details-list--showpass"
  }, [_c('div', {
    staticClass: "showpass-row"
  }, [_c('span', [_vm._v("Show Pass:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.strings.price))])]), _vm._v(" "), _c('div', {
    staticClass: "showpass-row showpass-row--total"
  }, [_c('span', [_vm._v("Total (one-time):")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.strings.price))])])]) : _c('div', {
    staticClass: "billing-details-list"
  }, [_c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "65"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.strings.cycle_label) + " Subscription:\n                                ")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_vm._v("\n                                    $" + _vm._s(_vm.strings.price) + "\n                                ")])], 1), _vm._v(" "), (_vm.promoApplied && _vm.promoData && _vm.promoData.valid) ? _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "65"
    }
  }, [_vm._v("\n                                    Coupon Discount:\n                                ")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_vm._v("\n                                    $" + _vm._s(_vm.promoData.amount_off ? (_vm.promoData.amount_off / 100) : (_vm.strings.price * _vm.promoData.percent_off / 100).toFixed(2)) + "\n                                ")])], 1) : _vm._e(), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "65"
    }
  }, [_vm._v("\n                                    Total billed on"), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.strings.tbd) + ":\n                                ")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35",
      "md-vertical-align": "end"
    }
  }, [_vm._v("\n                                    $" + _vm._s((_vm.promoApplied && _vm.promoData && _vm.promoData.valid) ? (_vm.strings.price - (_vm.promoData.amount_off ? (_vm.promoData.amount_off / 100) : (_vm.strings.price * _vm.promoData.percent_off / 100))).toFixed(2) : _vm.strings.price) + "\n                                ")])], 1)], 1)])]) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260e0e02","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/upgrade-account.vue
// module id = 1214
// module chunks = 21